import React from 'react';
import { useTranslation } from 'react-i18next';

const Locations = () => {
  const { t } = useTranslation();
  return <div>{t('locations_page.locations')}</div>;
};

export default Locations;
